<template>
	<div class="imgText">
		<div class="warp">
			<div class="banner">
				<img src="../static/8_2.png" alt="">
			</div>
			<!-- <p class="title">
				<span>王侯威仪</span>
				<em></em>
			</p>
			<div class="line"></div>
			<div style="overflow: scroll;padding-left:20px;">
				<ul class="tab-tilte">
			    	<li v-for="(title,index) in tabTitle" @click="tabdata(index)" :class="{active:cur==index}">{{title}}</li>
				</ul>
			</div> -->
			<div class="tab-content">
			  <div v-for="(m,index) in curdata">
			  		<dl v-for="item in m">
			  			<router-link tag="a" :to="{path:'detai',query:{id:item.id}}">
			  				<dt>
			  					<img :src="item.img" alt="">
			  				</dt>
			  			</router-link>
			  			<dd>{{item.title}}</dd>
			  		</dl>
			  </div>
			</div>
		</div>
		<div class="goback" @click="goback"></div>
	</div>
</template>
<script type="text/javascript">
	export default {
		data(){
			return{
				isActive:false,
				msg:'展开',
				tabTitle: ['礼乐宴飨', '车马出行','生活风尚','酎金积贮'],
				curdata:'',
				allData:{
					"data0":{
						data:[{
							id:18,
							img:require('../static/3_1.png'),
							title:'东壁 - 战士归来',
							etitle:'East Slab - Return of the Warrior',
							time:'公元前370-公元前360年',
							etime:'370/360 BC..',
							dimensional:'高139厘米；长103厘米；厚25厘米重685000克',
							edimensional:'Height 139cm ; Length 103cm; Thickness 25cm Weight 685000g',
							fromN:'拉盖多64号墓',
							efromN:'LAGHETTO T.64 LXIV',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>画面中面朝右侧站立的女性人物，穿着带有红色饰边和波浪纹饰的白色长裙，黑色鞋子，头上裹着由一个白色冠饰固定的黄色头纱。女子左手提着一只弧状把手水壶，右手向前递出一只双耳大饮杯，两个器皿均为黑色。女子的面前是一个面向左侧的骑士，骑着配白色鞍鞯的红马，身着红边白色短上衣，佩戴饰有两根白色羽毛的黄色头盔；他右手握着缰绳，左手持两根长矛，长矛搭在肩上，挂着一个锥形盾牌。</p><p>壁画上的其他彩绘装饰纹样（墓墙装饰系统）：三角墙的斜边上饰有白色线条、红色线条；红色线条中框有一个花环，花环圈出一颗石榴，两侧各有一根树枝；人物上方的红色线条勾勒出部分三角墙。</p>'
						},{
							id:19,
							img:require('../static/3_2.png'),
							title:'南壁 - 拳击和决斗',
							etitle:'South Slab - Boxing and Duel',
							time:'公元前370-公元前360年',
							etime:'370/360 BC.',
							material:'石灰岩',
							ematerial:'Travertin/Fresco',
							dimensional:'高96厘米；长214厘米；厚25厘米重1130000克',
							edimensional:'Height 96cm ; Length 214cm; Thickness 25cm Weight 113000g',
							fromN:'拉盖多64号墓',
							efromN:'LAGHETTO T. LXIV',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>覆有彩绘灰泥壁的石灰岩墓墙上，展现了拳击和决斗的场景。画面上有两个赤裸相向的拳击手。左侧的拳击手仅可见其右脚和右臂；右侧拳击手黑髯黑发，左腿前屈，右腿后蹬，左臂弯曲，攥拳于胸前，右臂向前击出。一棵非常低矮的小树苗将拳击手与身后的吹笛者分隔。画面中央一根大型爱奥尼亚式柱子将拳击场景与决斗场景区分开来。决斗场景位于两棵树苗之间。</p>'
						},{
							id:20,
							img:require('../static/3_3.png'),
							title:'北壁 - 战车比赛',
							etitle:'North Slab - Chariot Racing',
							time:'公元前370-公元前360年',
							etime:' 370/360 BC.',
							material:'石灰岩',
							ematerial:'Travertin/Fresco',
							dimensional:'高96厘米；长 217厘米；厚18厘米 重825000克',
							edimensional:'Height 96cm ; Length 217cm; Thickness 18cm Weight 825000g',
							fromN:'拉盖多64号墓',
							efromN:'LAGHETTO T. LXIV',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>这面墓墙由石灰岩构成，覆有灰泥壁，是拉盖多墓地中一座带有双坡顶的墓室的北墙。墓墙上的彩绘描绘了两辆向左行驶的战车，两车之间有一根装饰有红色丝带的爱奥尼亚式柱子。牵引第一辆战车的是前景中有着黄鬃的红马和后景中的黄马，两匹马都低头前行，战车的车体几乎不可见。驾车人也只是被简单勾画：第一辆战车由戴着白色尖帽、身着带红色衣襟白色长袍的男子驾驭，他黑髯黑发，左手握缰绳，右手持马鞭；第二辆战车由一匹黄马和一匹黑马牵引，两匹马的鼻子都为白色，同样低头前行。每辆战车的马匹上方都悬挂着垂花饰。墓墙右侧以一棵小树苗作结。</p><p>墓墙上还绘有白色、红色线条，以及带有树枝装饰的白色饰带。人物所在区域底色为白色，墓墙底部的底色是红色。</p>'
						},{
							id:22,
							img:require('../static/3_5.png'),
							title:'南壁 - 四马双轮战车',
							etitle:'South Slab - Quadriga',
							time:'公元前340-公元前330年',
							etime:'340/330 BC.',
							material:'石灰岩',
							ematerial:'Travertin/Fresco',
							dimensional:'高66厘米；长151厘米；厚19厘米重417000克',
							edimensional:'Height 66cm ; Length 151cm; Thickness 19cm Weight 417000g',
							fromN:'安德廖洛48号墓',
							efromN:'ANDRIUOLO T.48',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>这个战车比赛的场景被绘于一个双坡顶墓室的南墙上，墓墙为石灰岩，其上覆盖了灰泥壁和彩绘层。</p><p>画面中的战车由两匹红鬃黑白花马和两匹黑鬃白马拉动，向左奔跑的四匹马通过透视技法和不同的颜色呈现。驾驶战车者身着红、白、黑竖条纹的上衣，双手各持两条缰绳。双轮战车的透视在第一匹马的位置。</p><p>其他的彩绘图式有：一颗位于墓墙左侧、第四匹马前方的石榴；右侧边缘处有一条竖直的涡形装饰，末端也有一颗石榴。</p>'
						},{
							id:23,
							img:require('../static/3_6.png'),
							title:'西壁 - 狩猎野猪',
							etitle:'West Slab - Wild Boar Hunting',
							time:'公元前375-公元前350年',
							etime:'375/350 BC.',
							material:'石灰岩',
							ematerial:'Travertin/Fresco',
							dimensional:'高94厘米； 长92厘米； 厚9厘米 重175000克',
							edimensional:'Height 94cm ; Length 92cm; Thickness 9cm Weight 175000g',
							fromN:'安德廖洛6号墓',
							efromN:'ANDRIUOLOT. 6',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>这面石灰岩墓墙来自于安德廖洛墓的一座箱型石墓。墓墙描绘了一个猎人的形象。猎人身体朝向观者，头转向右侧。他留着黑色短发，佩戴着黑色饰发巾，身着浅色短罩衣，腰间系着一条黑边腰带，脚蹬带有红色装饰的黑靴；他的右手后举，准备投掷一根黑色长矛，左臂披着一件黑边绿衣。猎人的对面是一头被长矛刺伤的野猪，白色的猎犬在撕咬野猪的后背；画面中央的一条黑色猎犬正准备袭击野猪，而墓墙最右侧还能看见另一条准备扑咬野猪后背的白犬的一部分。野猪全身有三道猎狗和长矛造成的伤口，鲜血淋漓。野猪身后的背景中有一棵彩绘小树，黑犬背后也依稀可见另一棵小树。地面用波浪线呈现，最初的色彩可能是绿色。</p><p>壁画上的其他彩绘装饰纹样有（墓墙装饰系统）：红色线条与红色树枝，最初可能是绿色的心形叶片，黑色点状花朵，以及黑色线条。墓墙最底部有另一条黑色线条痕迹。<p>'
						},{
							id:24,
							img:require('../static/3_7.png'),
							title:'北壁 - 器物和植物纹饰',
							etitle:'North Slab - Objects and Plant Motifs',
							time:'公元前375-公元前350年',
							etime:'375/350 BC.',
							material:'石灰岩',
							ematerial:'Travertin/Fresco',
							dimensional:'高100厘米； 长217厘米； 厚16厘米 重770000克',
							edimensional:'Height 100cm ; Length 217cm; Thickness 16cm Weight 770000g',
							fromN:'安德廖洛6号墓',
							efromN:'ANDRIUOLO T. 6',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>这面墓墙上的彩绘描绘了不同的物品和植物纹饰：两只红底的黑色基利克斯杯被“钉”在墓墙上方；在这两只基利克斯杯之间，可以看到一条丝带的痕迹。</p><p>画面下方有一个双柄大口酒坛、一个弧状把手水壶和一个陶杯。这些容器的右侧是三条悬挂的丝带，两边的为红色，中间的为蓝色。壁画上的其他装饰纹样（墓墙装饰系统）由红色线条、有绿色心形叶片和黑色花朵的红色树枝，以及黑色线条构成。另一黑色线条位于墓墙下方。</p>'
						},{
							id:25,
							img:require('../static/3_8.png'),
							title:'红绘风格大口双耳高脚酒坛',
							etitle:'Red-figure Calyx-krater (bowl for mixing wine and water)',
							time:'公元前4世纪末期',
							etime:'Last decades of the IV century BC.',
							material:'陶',
							ematerial:'Ceramic',
							dimensional:'高40.5厘米； 直径37.3厘米 重4465克',
							edimensional:'Height 40.5cm ; Diameter 37.3cm Weight 4465g',
							fromN:'安德廖洛20A号墓',
							efromN:'ANDRIUOLO T. 20 A',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>意大利南部红绘风格基利克斯双耳陶杯，出土于安德廖洛8A号墓。杯身中央绘有一个面朝左侧的酒神的女祭司，她裸身于两棵月桂树之间，手中托着物品。</p>'
						},{
							id:21,
							img:require('../static/3_4.png'),
							title:'西壁 - 猎鹿',
							etitle:'West Slab - Deer Hunting',
							time:'公元前370-公元前360年',
							etime:'370/360 BC.',
							dimensional:'高139厘米；长100厘米；厚19厘米重500000克',
							edimensional:'Height 139cm ; Length 100cm; Thickness 19cm Weight 500000g',
							fromN:'拉盖多64号墓',
							efromN:'LAGHETTO T. LXIV',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>这面墓室西墙由覆有灰泥壁和彩绘层的石灰岩构成，它来自于一间双坡顶墓室。墙上的彩绘描绘了猎鹿的场景。</p><p>画面中的一头黄鹿奔向左侧，一条灰色猎犬跃上了它的脊背，正准备咬它的颈部。一名猎人紧随其后，左腿向前和右腿在后，左手竖直地拿着矛，靠在胸前，右手弯曲并微微前伸，搭一件红边白外套。场景的右侧是一棵小树苗。</p>'
						}]
					}	
				},
				cur: 0 //默认选中第一个tab
			}
		},
		mounted(){
			this.curdata=this.allData['data0'];
			//console.log(this.curdata,589)
		},
		methods:{
			slidUp(){
				this.isActive=!this.isActive;
				if (this.isActive) {
					this.msg='收起'
				}else{
					this.msg='展开'
				}
			},
			tabdata(index){
				this.cur=index;
				var code='data'+index;
				this.curdata=this.allData[code];
				//console.log(this.curdata,456)
			},
			goback(){
				this.$router.go(-1)
			}
		}
	}
</script>
<style scoped>
	.goback{
		width: 0.62rem;
		height: 0.62rem;
		background:url(../static/g.png);
		background-size: 100% 100%;
		border-radius:100%;
		position: fixed;
		right: 20px;
		top: 60%;
	}
	.line{
		width:1rem;
		height: 1px;
		background:#ececec;
		margin: 0 auto;
		margin-bottom: .3rem;
	}
	.warp{
		width: 90%;
		margin: 0 auto;
		background:#fff;
		box-shadow: 0px 1px 15px #ededed;
		margin-top: 20px;
		border-radius:20px;
		padding-bottom:1rem;
		margin-bottom: 1rem;
	}
	.banner{
		width: 100%;
		border-top-left-radius:20px;
		border-top-right-radius:20px;
		margin-bottom: 0.4rem;
	}
	.banner img{
		width: 100%;
		border-top-left-radius:20px;
		border-top-right-radius:20px;
	}
	.title{
		width: 100%;
		text-align: left;
		font-size:20px;
		position: relative;
		margin-bottom: .8rem;
	}
	.title span{
		text-indent:0.14rem;
		letter-spacing: 3px;
		display: inline-block;
		z-index: 3;
		position: absolute;
	}
	.title em{
		display: inline-block;
		width: 0.85rem;
		height:9px;
		background: #e6bb70;
		left: 0.20rem;
		position: absolute;
		z-index: 1;
		top:10px;
	}
	.cont{
		width: 90%;
		margin: 0 auto;
	}
	.cont p{
		font-size: 16px;
		color:#666666;
		line-height: 30px;
		text-align: justify;
		margin-bottom: .10rem;
	}
	.cont dl{
		width: 100%;
		margin-bottom:.10rem;
	}
	.cont dl dt img{
		width: 100%;
	}
	.cont dl dd{
		font-size:14px;
		color:#adadad;
		margin-top: 0.15rem;
		line-height: 20px;
	}
	.butn{
		background:url(../static/bj1.png);
		height:.4rem;
		background-size: 100%;
		margin-top:.25rem;
		position: relative;
	}
	.btnC{
		width: 0.45rem;
		height: 0.23rem;
		border-radius: 50px;
		background:#fff;
		box-shadow: 0px 1px 15px #ededed;
		text-align: center;
		line-height: 0.23rem;
		margin: 0 auto;
		margin-top: -0.11rem;
		position: absolute;
		left: 50%;
		margin-left: -0.25rem;
		color:#e6bb70;
	}
	.activeClass{
		height: 2rem;
		overflow:hidden;
	}
	.hideClass{
		height: auto;
	}
	.tab-tilte{
	    width:1500px;
	}
	.tab-tilte li{
	    float: left;
	    width:1rem;
	    padding: 10px 0;
	    text-align: center;
	    cursor: pointer;
	    color:#cdcdcd;
	    font-size: 18px;
	    font-weight: bolder;
	}
	/* 点击对应的标题添加对应的背景颜色 */
	.tab-tilte .active{
	    color: #e6bb70;
	}
	.tab-content div{
	    width:95%;
	  	margin-top:.2rem;
	  	column-count:2;
	}		
	.tab-content div dl{
		background:#f5f5f5;
		border-radius: 4px;
		margin-left: 22px;
		padding-bottom: 30px;
		background: #fff;
	}
	.tab-content div dl dt{
		justify-content: center;
		align-items: center;
	}
	.tab-content div dl dt img{
		max-width:100%;
		max-height: 100%;
		border-radius: 4px 4px 0 0;
	}
	.tab-content div dl dd{
		height: .3rem;
		background:#fff;
		line-height: .3rem;
		text-align: center;
		border-bottom-right-radius:4px;
		border-bottom-left-radius:4px;
		overflow: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
		padding:0 5px; 
		box-shadow: 0px 1px 15px #d7d7d7;
	}
</style>